import React from 'react';
import {
    Button, Modal, Radio, Checkbox, Col, Row,
} from 'antd';
import { connect } from 'react-redux';
import { addBikeLeadUpgrades, removeBikeLeadUpgrades } from '../../requests/bike_lead_upgrades_request';
import { getLeadProfile } from '../../requests/get_lead_profile_request';
import {
    updateBikeLeadUpgradesRequest,
    updateBikeLeadUpgradesSuccess,
} from '../../redux/actions/change_ref_bike_lead.actions';
import BikeOtherUpgrades from './BikeOtherUpgrades';
import { EXHAUST_CATEGORY_ID, OTHER_CATEGORY_ID } from '../../../constants/bikeUpgrades';

class BikeUpgradesModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isFetching: false,
            currentCategory: this.props.bikeUpgradesCategories?.[0]?._id || '',
            selectedUpgrades: this.buildInitialSelectedUpgrades(),
            initialSelectedUpgrades: this.buildInitialSelectedUpgrades(),
            initialUpgradesTree: this.buildInitialUpgrades(),
        };
    }

    handleSaveModal = () => {
        this.handleCreateBikeLeadUpgrade();
    };

    handleCancelModal = () => {
        const { initialSelectedUpgrades } = this.state;
        this.setState({ selectedUpgrades: initialSelectedUpgrades });
        this.props.handleIsModalOpen(false);
    };

    handleCreateBikeLeadUpgrade = async () => {
        this.setState({ isFetching: true });
        const { bikeLeadId } = this.props;
        const { selectedUpgrades, initialSelectedUpgrades } = this.state;

        let flattenSelectedUpgradesList = [];
        let flattenInitialUpgradesList = [];


        Object.keys(selectedUpgrades).forEach((category) => {
            if (category !== OTHER_CATEGORY_ID) {
                flattenSelectedUpgradesList = [...flattenSelectedUpgradesList, ...selectedUpgrades[category]];
            }
        });

        Object.keys(initialSelectedUpgrades).forEach((category) => {
            if (category !== OTHER_CATEGORY_ID) {
                flattenInitialUpgradesList = [...flattenInitialUpgradesList, ...initialSelectedUpgrades[category]];
            }
        });


        const upgradesToDelete = flattenInitialUpgradesList.filter(
            (initialUpgrade) => flattenSelectedUpgradesList.indexOf(initialUpgrade) === -1,
        );

        const bikeLeadUpgradeIdsToDelete = upgradesToDelete.map((upgradeId) => this.props.bikeLeadUpgrades
            .find((item) => item.ref_bike_lead_upgrades._id === upgradeId)
            ._id);

        const upgradeIdsToCreate = flattenSelectedUpgradesList.filter(
            (selectedUpgrade) => flattenInitialUpgradesList.indexOf(selectedUpgrade) === -1,
        );

        if (bikeLeadUpgradeIdsToDelete?.length) {
            for (const bikeLeadUpgradeId of bikeLeadUpgradeIdsToDelete) {
                await removeBikeLeadUpgrades(bikeLeadId, bikeLeadUpgradeId);
            }
        }

        if (upgradeIdsToCreate?.length) {
            for (const upgradeId of upgradeIdsToCreate) {
                await addBikeLeadUpgrades(bikeLeadId, upgradeId);
            }
        }

        const selectedOtherUpdates = selectedUpgrades[OTHER_CATEGORY_ID];
        const initialSelectedOtherUpdates = initialSelectedUpgrades[OTHER_CATEGORY_ID];

        let otherUpgradeIdsToDelete = [];
        let otherUpgradesToCreate = [];

        if (Array.isArray(selectedOtherUpdates)) {
            otherUpgradeIdsToDelete = initialSelectedOtherUpdates
                .filter((initialUpgrade) => selectedOtherUpdates.findIndex(
                    (currentUpgrade) => currentUpgrade.deleteId === initialUpgrade.deleteId,
                ) === -1)
                .map((upgrade) => upgrade.deleteId);

            otherUpgradesToCreate = selectedOtherUpdates
                .filter((initialUpgrade) => initialSelectedOtherUpdates.findIndex(
                    (currentUpgrade) => currentUpgrade.name === initialUpgrade.name,
                ) === -1)
                .map((upgrade) => upgrade.name);

            if (otherUpgradeIdsToDelete?.length) {
                for (const bikeLeadUpgradeId of otherUpgradeIdsToDelete) {
                    await removeBikeLeadUpgrades(bikeLeadId, bikeLeadUpgradeId);
                }
            }

            if (otherUpgradesToCreate?.length) {
                for (const upgradeName of otherUpgradesToCreate) {
                    await addBikeLeadUpgrades(bikeLeadId, OTHER_CATEGORY_ID, upgradeName);
                }
            }
        }

        this.setState({ isFetching: false });
        this.props.handleIsModalOpen(false);

        if (bikeLeadUpgradeIdsToDelete?.length
            || upgradeIdsToCreate?.length
            || otherUpgradeIdsToDelete?.length
            || otherUpgradesToCreate?.length
        ) {
            this.props.updateBikeLeadUpgradesRequest();

            const leadResponse = await getLeadProfile(window.location.pathname.split('/').pop());

            this.props.updateBikeLeadUpgradesSuccess('upgrades', leadResponse?.options?.ref_bike_lead?.upgrades);
        }
    };

    handleChangeCategory = (e) => {
        this.setState({ currentCategory: e.target.value });
    };

    handleChangeSubCategory = (value) => {
        this.setState((prevState) => {
            const updatedSelectedUpgrades = { ...prevState.selectedUpgrades };

            updatedSelectedUpgrades[prevState.currentCategory] = value;

            return {
                ...prevState,
                selectedUpgrades: updatedSelectedUpgrades,
            };
        });
    };

    handleChangeRadioSubCategory = (e) => {
        this.setState((prevState) => ({
            ...prevState,
            selectedUpgrades: { ...prevState.selectedUpgrades, [prevState.currentCategory]: [e.target.value] },
        }));
    }

    handleAddNewOtherUpgrades = (value, id) => {
        this.setState((prevState) => {
            const updatedSelectedUpgrades = { ...prevState.selectedUpgrades };
            let otherCategoryArray = [...updatedSelectedUpgrades[OTHER_CATEGORY_ID]];
            const obj = { deleteId: null, name: value || '', customId: id };

            if (value !== null && !value.trim()) {
                otherCategoryArray = otherCategoryArray.filter((el) => (el.deleteId || el.customId) !== id);
            } else if (otherCategoryArray.length) {
                otherCategoryArray = otherCategoryArray.map((el) => ((el.deleteId || el.customId) === id && el.name !== value ? obj : el));
            } else {
                otherCategoryArray.push(obj);
            }

            return {
                ...prevState,
                selectedUpgrades: { ...updatedSelectedUpgrades, [OTHER_CATEGORY_ID]: otherCategoryArray },
            };
        });
    };

    handleDeleteOtherUpgrades = (deleteUpgradeName) => {
        this.setState((prevState) => {
            const updatedSelectedOtherUpgrades = [...prevState.selectedUpgrades[OTHER_CATEGORY_ID]];

            const deleteUpgradeIdx = updatedSelectedOtherUpgrades.findIndex((upgrade) => upgrade.name === deleteUpgradeName);

            if (deleteUpgradeIdx !== -1) {
                updatedSelectedOtherUpgrades.splice(deleteUpgradeIdx, 1);
            }
            return {
                ...prevState,
                selectedUpgrades: {
                    ...prevState.selectedUpgrades,
                    [OTHER_CATEGORY_ID]: [...updatedSelectedOtherUpgrades],
                },
            };
        });
    };

    updateSelectedOtherUpgrades = () => {

    };

    buildInitialUpgrades = () => this.props.bikeUpgradesList.reduce((acc, upgrade) => {
        if (!upgrade.parent_id) {
            return acc;
        }

        if (acc[upgrade.parent_id]) {
            acc[upgrade.parent_id].push(upgrade);
        } else {
            acc[upgrade.parent_id] = [upgrade];
        }

        return acc;
    }, {});

    buildInitialSelectedUpgrades = () => {
        const selectedUpgrades = {};

        this.props.bikeUpgradesCategories.forEach((category) => {
            selectedUpgrades[category._id] = [];
        });

        if (Array.isArray(this.props.bikeLeadUpgrades) && this.props.bikeLeadUpgrades.length) {
            this.props.bikeLeadUpgrades.forEach((upgrade) => {
                if (upgrade.ref_bike_lead_upgrades.parent_id) {
                    selectedUpgrades[upgrade.ref_bike_lead_upgrades.parent_id].push(upgrade.ref_bike_lead_upgrades._id);
                } else {
                    selectedUpgrades[OTHER_CATEGORY_ID].push({ name: upgrade.additional_mod, deleteId: upgrade._id });
                }
            });
        }

        return selectedUpgrades;
    };

    render() {
        const { bikeUpgradesCategories } = this.props;

        return (
            <Modal
                visible={this.props.isModalOpen}
                title="Edit Aftermarket Parts"
                onOk={this.handleSaveModal}
                onCancel={this.handleCancelModal}
                maskClosable={false}
                closable={false}
                width={700}
                footer={[
                    <Button
                        key="back"
                        onClick={this.handleCancelModal}
                        disabled={this.state.isFetching}
                    >
                        Cancel
                    </Button>,
                    <Button
                        key="submit"
                        type="primary"
                        loading={this.state.isFetching}
                        disabled={this.state.isFetching}
                        onClick={this.handleSaveModal}
                    >
                        Save
                    </Button>,
                ]}
            >
                <Radio.Group
                    buttonStyle="solid"
                    value={this.state.currentCategory}
                    onChange={this.handleChangeCategory}
                >
                    {bikeUpgradesCategories?.map((category) => (
                        <Radio.Button value={category._id} key={category._id}>{category.name}</Radio.Button>
                    ))}
                </Radio.Group>

                <div>
                    {
                        ![OTHER_CATEGORY_ID, EXHAUST_CATEGORY_ID].includes(this.state.currentCategory)
                             && (
                                 <Checkbox.Group
                                     style={{ width: '100%' }}
                                     onChange={this.handleChangeSubCategory}
                                     value={this.state.selectedUpgrades[this.state.currentCategory]}
                                 >
                                     <div style={{ marginTop: 30 }}>
                                         <Row>
                                             {this.state.initialUpgradesTree[this.state.currentCategory]?.map((upgrade) => (
                                                 <Col span={8} style={{ marginBottom: 20 }} key={upgrade._id}>
                                                     <Checkbox value={upgrade._id}>{upgrade.name}</Checkbox>
                                                 </Col>
                                             ))}
                                         </Row>

                                     </div>
                                 </Checkbox.Group>
                             )}
                    { this.state.currentCategory === EXHAUST_CATEGORY_ID && (
                        <Radio.Group
                            style={{ width: '100%' }}
                            onChange={this.handleChangeRadioSubCategory}
                            value={this.state.selectedUpgrades[this.state.currentCategory][0]}
                        >
                            <div style={{ marginTop: 30 }}>
                                <Row>
                                    {this.state.initialUpgradesTree[this.state.currentCategory]?.map((upgrade) => (
                                        <Col span={8} style={{ marginBottom: 20 }} key={upgrade._id}>
                                            <Radio value={upgrade._id}>{upgrade.name}</Radio>
                                        </Col>
                                    ))}
                                </Row>

                            </div>
                        </Radio.Group>
                    )}
                    { this.state.currentCategory === OTHER_CATEGORY_ID && (
                        <BikeOtherUpgrades
                            selectedUpgrades={this.state.selectedUpgrades[OTHER_CATEGORY_ID]}
                            handleAddNewOtherUpgrades={this.handleAddNewOtherUpgrades}
                            handleDeleteOtherUpgrades={this.handleDeleteOtherUpgrades}
                        />
                    )
                    }
                </div>
            </Modal>
        );
    }
}

export default connect(
    null,
    {
        updateBikeLeadUpgradesRequest,
        updateBikeLeadUpgradesSuccess,
    },
)(BikeUpgradesModal);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Lead_profile_table/BikeUpgradesModal.js